
import {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonSpinner,
    IonIcon,
    IonButtons,
    IonButton,
    IonInput,
    menuController,
    alertController,
} from "@ionic/vue";
import { refresh, menu, checkmark, close } from "ionicons/icons";

import { computed, ref } from "vue";

import { LOCALSTORAGE_KEY } from "@/custom_config";

import { dateFormat } from "@/services/utils";
import { openToast } from "@/services/toast";
import apiResponsabile from "@/services/responsabile";

export default {
    name: "RiepilogoRichieste",
    components: {
        IonHeader,
        IonToolbar,
        IonTitle,
        IonContent,
        IonPage,
        IonSpinner,
        IonIcon,
        IonButtons,
        IonButton,
        IonInput,
    },
    setup() {
        const userID = JSON.parse(localStorage.getItem(`${LOCALSTORAGE_KEY}`)).dipendenti_user_id;
        const dipendenteID = JSON.parse(localStorage.getItem(`${LOCALSTORAGE_KEY}`)).dipendenti_id;

        const loading = ref(false);
        const processing = ref(false);
        const richieste = ref([]);
        const searchQuery = ref("");

        const openMenu = () => {
            menuController.open("app-menu");
        };

        /**
         * Load all pending requests for approval
         */
        async function loadRichieste() {
            loading.value = true;
            try {
                const response = await apiResponsabile.getRichieste(dipendenteID);
                console.log(response);
                if(response.status === 200 && response.data.status === 0) {
                    richieste.value = response.data.data;
                } else {
                    openToast("Errore durante il caricamento delle richieste", "toast_danger");
                    richieste.value = [];
                }
            } catch (error) {
                console.error(error);
                openToast("Errore durante il caricamento delle richieste", "toast_danger");
                richieste.value = [];
            }
            loading.value = false;
        }
        loadRichieste();

        /**
         * Filter requests based on search query
         */
        const richiesteToShow = computed(() => {
            return richieste.value.filter((richiesta) => {
                const searchTerm = searchQuery.value.toLowerCase();
                if (!searchTerm) {
                    return true;
                }

                const tipologiaMatch = richiesta.richieste_tipologia_value && 
                    richiesta.richieste_tipologia_value.toLowerCase().includes(searchTerm);
                const nomeMatch = richiesta.dipendenti_nome && 
                    richiesta.dipendenti_nome.toLowerCase().includes(searchTerm);
                const cognomeMatch = richiesta.dipendenti_cognome && 
                    richiesta.dipendenti_cognome.toLowerCase().includes(searchTerm);
                const noteMatch = richiesta.richieste_note && 
                    richiesta.richieste_note.toLowerCase().includes(searchTerm);
                
                return tipologiaMatch || nomeMatch || cognomeMatch || noteMatch;
            });
        });

        /**
         * Approve a request
         */
        async function approveRichiesta(richiestaId: string) {
            const alert = await alertController.create({
                header: 'Conferma approvazione',
                message: 'Sei sicuro di voler approvare questa richiesta?',
                buttons: [
                    {
                        text: 'Annulla',
                        role: 'cancel'
                    },
                    {
                        text: 'Approva',
                        handler: async () => {
                            await setStatoRichiesta(richiestaId, '2');
                        }
                    }
                ]
            });
            await alert.present();
        }

        /**
         * Reject a request
         */
        async function rejectRichiesta(richiestaId: string) {
            const alert = await alertController.create({
                header: 'Conferma rifiuto',
                message: 'Sei sicuro di voler rifiutare questa richiesta?',
                buttons: [
                    {
                        text: 'Annulla',
                        role: 'cancel'
                    },
                    {
                        text: 'Rifiuta',
                        handler: async () => {
                            await setStatoRichiesta(richiestaId, '3');
                        }
                    }
                ]
            });
            await alert.present();
        }

        /**
         * Set request status (approve or reject)
         */
        async function setStatoRichiesta(richiestaId: string, stato: string) {
            processing.value = true;
            try {
                await apiResponsabile.setStato(richiestaId, stato);
                const statoText = stato === '2' ? 'approvata' : 'rifiutata';
                openToast(`Richiesta ${statoText} con successo`, "toast_success");
                
                // Remove the request from the local array instead of reloading
                richieste.value = richieste.value.filter(richiesta => richiesta.richieste_id !== richiestaId);
            } catch (error) {
                console.error(error);
                openToast("Errore durante l'aggiornamento della richiesta", "toast_danger");
            }
            processing.value = false;
        }

        return {
            loading,
            processing,
            refresh,
            menu,
            checkmark,
            close,
            richieste,
            richiesteToShow,
            searchQuery,
            dateFormat,
            loadRichieste,
            openMenu,
            approveRichiesta,
            rejectRichiesta,
        };
    },
};
